import React from 'react';
import { SecondaryButton } from '@chegg-ui/button';
import { onSecondaryCtaButtonClick } from '../helpers';
export var renderSecondaryButton = function renderSecondaryButton(_ref) {
  var cta = _ref.cta,
    isDisabled = _ref.isDisabled,
    loading = _ref.loading,
    _onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(SecondaryButton, {
    "data-test": 'SECONDARY_CTA_BUTTON',
    onClick: function onClick(event) {
      return onSecondaryCtaButtonClick(event, _onClick);
    },
    disabled: isDisabled,
    isLoading: loading
  }, /*#__PURE__*/React.createElement("span", null, cta));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/CTA/variants/SecondaryButton.js
// module id = 3972
// module chunks = 11